<div  class="w-11/12 mx-auto px-6 py-8" data-aos="fade-up">
  <div class="flex items-center justify-between border-b-2 border-yellow-400 pb-2 mb-6">
    <div class="text-xl text-primary-600">{{ 'Fursa, Takwimu na Taarifa Muhimu'|concat|translate }}</div>
  </div>

  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" appSequentialAnimate direction="vertical" *ngIf="statisticSites$| async as statics">
    <ng-container *ngFor="let s of statics | slice:0:8">
      <div class="p-1 flex flex-col">
        <div class="font-bold text-primary-500">
          <div class="border-r-3 border-primary-500 h-2"></div>
          {{ s.title }}
        </div>
        <ng-container *ngFor="let l of s.sites">
          <div  class="pt-2 flex items-center gap-2  ">
            <mat-icon class="text-gray-500 align-middle ">north_east</mat-icon>
            <a href="{{l?.url}}" target="_blank" class="text-gray-500 text-decoration-none">{{ l.title }}</a>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </div>
</div>
